import React from 'react';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import DeviationSidebarGrid from '../../../_partials/DeviationSidebarGrid';
/** Sidebar block layout id 1 */
var DeviationGrid3X3 = function (_a) {
    var _b;
    var block = _a.block, parentDeviation = _a.deviation;
    return (React.createElement(SidebarBlockWrapper, { deviation: parentDeviation, block: block },
        React.createElement(DeviationSidebarGrid, { streamId: "sidebar-3x3-".concat(block.contentType), deviations: (_b = block.deviations) !== null && _b !== void 0 ? _b : [], parentDeviation: parentDeviation, maxRows: 3 })));
};
DeviationGrid3X3.displayName = 'DeviationGrid3X3';
export default DeviationGrid3X3;
//# sourceMappingURL=DeviationGrid3X3.js.map